import Vue from 'vue';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (campaignId, clients) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`news_campaigns/${campaignId}/clients`, clients)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/clientCampaign/store.js